


import React from "react";
import { Link } from "react-router-dom";

import { useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { MdOutlineDashboard } from "react-icons/md";
import { IoPeopleOutline } from "react-icons/io5";
import { BsPerson } from "react-icons/bs";
import { CgGirl } from "react-icons/cg";
import { IoCameraOutline } from "react-icons/io5";
import { GiFlowers } from "react-icons/gi";

export const Sidebar = ({ isOpen, toggleSidebar }) => {
    // const [activeMenu, setactiveMenu] = useState("dashboard");
//   const location = useLocation();
// const pathname = location.pathname;


const activeMenu = sessionStorage.getItem("menuName") || "Dashboard";


  const handleMenuClick = (menuName) => {
    sessionStorage.setItem("menuName", menuName);
  };
  return (
    <div
      style={{
        width: window.innerWidth >= 992 ? "250px" : "100vw", // Fixed width on large screens, full width on mobile
        
        height: "100vh",
        position: "fixed",
        left: isOpen || window.innerWidth >= 992 ? "0" : "-100vw", // Always visible on large screens
        top: 0,
        transition: "left 0.3s ease-in-out",
        zIndex: 1000, // Ensure it appears above other elements
      }}
      className="sidebarBG"
    >
      {/* Close Button (Only Visible on Small Screens) */}
      {window.innerWidth < 992 && isOpen && (
        <button
          onClick={toggleSidebar}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
          className="close-btn"
        >
          ✖
        </button>
      )}

      <div className="sidebarLogo">
       <img src={logo} />
       </div>
     <ul className="sidebar-list">
      <li 
         onClick={() => {
            toggleSidebar(); 
            handleMenuClick("Dashboard", "/dashboard")
           
          }}
          // className={pathname === "/dashboard" ? "activeMenu" : ""}
          className={activeMenu === "Dashboard" ? "activeMenu" : ""}

        >
          <a href="/dashboard">
            {" "}
            <span className="pe-2">
              <MdOutlineDashboard />
            </span>
            Dashboard
          </a>
        </li>
     


        <li 
         onClick={() => {
            toggleSidebar(); 
            handleMenuClick("UserProfiles", "/user-profiles")
         
          }}
        //  className={pathname === "/user-profiles" ? "activeMenu" : ""}
          className={activeMenu === "UserProfiles" ? "activeMenu" : ""}

        >
          <a href="/user-profiles">
            {" "}
            <span className="pe-2">
          <IoPeopleOutline />
            </span>
            User Profiles
          </a>
        </li>
        <li 
         onClick={() => {
            toggleSidebar(); 
            handleMenuClick("Matchmakers", "/matchmakers")
        
          }}
          // className={pathname === "/matchmakers" ? "activeMenu" : ""}
          className={activeMenu === "Matchmakers" ? "activeMenu" : ""}

        >
          <a href="/matchmakers">
            {" "}
            <span className="pe-2">
               <BsPerson />
            </span>
           Matchmakers
          </a>
        </li>
        <li 
         onClick={() => {
            toggleSidebar(); 
            handleMenuClick("Beauticians", "/beauticians")
           
          }}
      //  className={pathname === "/beauticians" ? "activeMenu" : ""}
      className={activeMenu === "Beauticians" ? "activeMenu" : ""}

        >
          <a href="/beauticians"><span className="pe-2"><CgGirl /></span>Beauticians</a>
        </li>
        <li 
         onClick={() => {
            toggleSidebar(); 
            handleMenuClick("Photographers", "/photographers")
         
          }}
        //  className={pathname === "/photographers" ? "activeMenu" : ""}
         className={activeMenu === "Photographers" ? "activeMenu" : ""}

        >
          <a href="/photographers"><span className="pe-2"><IoCameraOutline /></span>Photographers</a>
        </li>
        <li 
         onClick={() => {
            toggleSidebar(); 
            handleMenuClick("EventManagers", "/event-manager")
           
          }}
          // className={pathname === "/event-manager" ? "activeMenu" : ""}
            className={activeMenu === "EventManagers" ? "activeMenu" : ""}

        >
          <a href="/event-manager"><span className="pe-2"><GiFlowers /></span>Event Hall Managers</a>
        </li>
       
      </ul>

    </div>
  );
};

